module.exports = __webpack_public_path__ + "static/media/login-2fa.2cdcc936.svg";